export { CommonlySearchedCard } from './CommonlySearched';
